import { render } from "./VScript.vue?vue&type=template&id=7fc49bf4"
import script from "./VScript.vue?vue&type=script&lang=js"
export * from "./VScript.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__